import { Injectable } from "@angular/core";
@Injectable()
export class GenreTransformer {
    fromCatType(item, alterLink) {
        let result;
        if (alterLink) {
            result = {
                title: item.className,
                id: item.altLink ? item.altLink.split('?CID=')[1] : item.path,
                prompt: item.isIndex,
                region:item.region
            };
        } else {
            result = {
                title: item.className,
                id: item.path,
                prompt: item.isIndex,
                region:item.region
            };
        }
        return result;
    }
}

